import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import withRenderedMain from 'components-framework/view/with_rendered_main';
import {DocumentUploadView} from './view';
import {DocumentUploadModel} from './model';
import {WIDGET_NAME} from './constants';

export function createEventsMap(id) {
    return {
        [`${id}:onClickBackButton`]: 'onClickBackButton',
        [`${id}:onClickDoneButton`]: 'onClickDoneButton',
        [`${id}:onNoBookingAttachments`]: 'onNoBookingAttachments',
    };
}

const factory = createWidgetFactory({
    name: WIDGET_NAME,
    modelClass: DocumentUploadModel,
    viewClass: withRenderedMain(DocumentUploadView),
    methods: {
        init(props) {
            this.model.init(props.email, props.bookingID);
        },
    },
});
export default {
    factory,
    createEventsMap,
};
